import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import * as WpBlocksApi from '@wordpress/blocks';
import SprocketIcon from '../Common/SprocketIcon';
import StylesheetErrorBondary from '../Common/StylesheetErrorBondary';
import FormBlockSave from './FormBlockSave';
import { connectionStatus } from '../../constants/leadinConfig';
import FormGutenbergPreview from './FormGutenbergPreview';
import ErrorHandler from '../../shared/Common/ErrorHandler';
import FormEdit from '../../shared/Form/FormEdit';
import ConnectionStatus from '../../shared/enums/connectionStatus';
import { __ } from '@wordpress/i18n';
import { isFullSiteEditor } from '../../utils/withMetaData';
export default function registerFormBlock() {
    const editComponent = (props) => {
        const isPreview = props.attributes.preview;
        const isConnected = connectionStatus === ConnectionStatus.Connected;
        return (_jsx(StylesheetErrorBondary, { children: isPreview ? (_jsx(FormGutenbergPreview, {})) : isConnected ? (_jsx(FormEdit, { ...props, origin: "gutenberg", preview: true })) : (_jsx(ErrorHandler, { status: 401 })) }));
    };
    // We do not support the full site editor: https://issues.hubspotcentral.com/browse/WP-1033
    if (!WpBlocksApi || isFullSiteEditor()) {
        return null;
    }
    WpBlocksApi.registerBlockType('leadin/hubspot-form-block', {
        title: __('HubSpot Form', 'leadin'),
        description: __('Select and embed a HubSpot form', 'leadin'),
        icon: SprocketIcon,
        category: 'leadin-blocks',
        attributes: {
            portalId: {
                type: 'string',
                default: '',
            },
            formId: {
                type: 'string',
            },
            formName: {
                type: 'string',
            },
            preview: {
                type: 'boolean',
                default: false,
            },
        },
        example: {
            attributes: {
                preview: true,
            },
        },
        edit: editComponent,
        save: props => _jsx(FormBlockSave, { ...props }),
    });
}
